document.addEventListener('DOMContentLoaded', () => {
// Banner Slider
const sliders = document.querySelectorAll('[data-banner-slider]');

sliders.forEach((slider) => {
  const track = slider.querySelector('[data-banner-slider-track]');
  const slides = Array.from(slider.querySelectorAll('[data-banner-slide]'));
  const dots = Array.from(slider.querySelectorAll('[data-banner-slider-dot]'));

  if (!track || slides.length <= 1) {
    return;
  }

  const autoplayEnabled = slider.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(slider.dataset.autoplaySpeed || '5000', 10);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const firstClone = slides[0].cloneNode(true);
  const lastClone = slides[slides.length - 1].cloneNode(true);

  firstClone.setAttribute('aria-hidden', 'true');
  lastClone.setAttribute('aria-hidden', 'true');
  firstClone.classList.add('is-clone');
  lastClone.classList.add('is-clone');

  track.appendChild(firstClone);
  track.insertBefore(lastClone, slides[0]);

  const allSlides = Array.from(track.querySelectorAll('[data-banner-slide], .is-clone'));
  let currentIndex = 1;
  let autoplayTimer = null;
  let isTransitioning = false;

  const setTrackPosition = (index, withTransition = true) => {
    track.style.transition = withTransition && !reduceMotion ? 'transform 0.65s ease' : 'none';
    track.style.transform = `translateX(-${index * 100}%)`;
  };

  const updateDots = () => {
    let realIndex = currentIndex - 1;

    if (currentIndex === 0) {
      realIndex = slides.length - 1;
    } else if (currentIndex === slides.length + 1) {
      realIndex = 0;
    }

    slides.forEach((slide, slideIndex) => {
      slide.classList.toggle('is-active', slideIndex === realIndex);
      slide.setAttribute('aria-hidden', String(slideIndex !== realIndex));
    });

    dots.forEach((dot, dotIndex) => {
      const isActive = dotIndex === realIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-pressed', String(isActive));
    });
  };

  const goToSlide = (index) => {
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex = index;
    setTrackPosition(currentIndex, true);
    updateDots();
  };

  const goToNext = () => {
    goToSlide(currentIndex + 1);
  };

  const goToPrev = () => {
    goToSlide(currentIndex - 1);
  };

  const stopAutoplay = () => {
    if (autoplayTimer) {
      window.clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };

  const startAutoplay = () => {
    if (!autoplayEnabled || reduceMotion) {
      return;
    }

    stopAutoplay();
    autoplayTimer = window.setInterval(goToNext, Math.max(autoplaySpeed, 3000));
  };

  track.addEventListener('transitionend', () => {
    if (currentIndex === slides.length + 1) {
      currentIndex = 1;
      setTrackPosition(currentIndex, false);
    }

    if (currentIndex === 0) {
      currentIndex = slides.length;
      setTrackPosition(currentIndex, false);
    }

    isTransitioning = false;
    updateDots();
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.index || '0', 10);
      goToSlide(index + 1);
      startAutoplay();
    });
  });

  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);
  slider.addEventListener('focusin', stopAutoplay);
  slider.addEventListener('focusout', startAutoplay);

  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener(
    'touchstart',
    (event) => {
      touchStartX = event.changedTouches[0].clientX;
    },
    { passive: true }
  );

  slider.addEventListener(
    'touchend',
    (event) => {
      touchEndX = event.changedTouches[0].clientX;
      const swipeDistance = touchStartX - touchEndX;

      if (Math.abs(swipeDistance) < 40) {
        return;
      }

      if (swipeDistance > 0) {
        goToNext();
      } else {
        goToPrev();
      }

      startAutoplay();
    },
    { passive: true }
  );

  setTrackPosition(currentIndex, false);
  updateDots();
  startAutoplay();
});




 // Testimonial Slider
  const testimonialSections = document.querySelectorAll('[data-testimonial-slider]');

  testimonialSections.forEach((section) => {
    const root = section.querySelector('[data-testimonial-viewport]');
    const track = section.querySelector('[data-testimonial-track]');
    const list = section.querySelector('[data-testimonial-list]');
    const slides = Array.from(section.querySelectorAll('[data-testimonial-slide]'));

    if (!root || !track || !list || slides.length <= 1 || typeof window.Splide !== 'function') {
      return;
    }

    root.classList.add('splide');
    track.classList.add('splide__track');
    list.classList.add('splide__list');
    slides.forEach((slide) => slide.classList.add('splide__slide'));

    const autoplayEnabled = section.dataset.autoplay === 'true';
    const autoplaySpeed = parseInt(section.dataset.autoplaySpeed || '5000', 10);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const splide = new window.Splide(root, {
      type: 'loop',
      arrows: false,
      pagination: false,
      drag: true,
      autoplay: autoplayEnabled && !reduceMotion,
      interval: Math.max(autoplaySpeed, 3000),
      pauseOnHover: true,
      pauseOnFocus: true,
      speed: reduceMotion ? 0 : 650,
      gap: '22px',
      perPage: 2,
      perMove: 1,
      focus: 0,
      trimSpace: false,
      padding: {
        left: '16.666%',
        right: '16.666%'
      },
      breakpoints: {
        989: {
          perPage: 2,
          gap: '20px',
          focus: 0,
          padding: {
            left: '0px',
            right: '0px'
          }
        },
        749: {
          perPage: 1,
          gap: '16px',
          focus: 0,
          padding: {
            left: '0px',
            right: '0px'
          }
        }
      }
    });

    const updateActiveCard = () => {
      const isDesktop = window.innerWidth > 989;
      const activeRealIndex = isDesktop
        ? (splide.index + 2) % slides.length
        : splide.index % slides.length;

      root.querySelectorAll('.testimonial-card').forEach((card) => {
        card.classList.remove('is-active');
      });

      root.querySelectorAll('.testimonial-slider__slide').forEach((slide) => {
        const slideIndex = parseInt(slide.getAttribute('data-splide-index') || '-1', 10);
        const normalizedIndex = ((slideIndex % slides.length) + slides.length) % slides.length;

        if (normalizedIndex !== activeRealIndex) {
          return;
        }

        const card = slide.querySelector('.testimonial-card');
        if (card) {
          card.classList.add('is-active');
        }
      });
    };

    splide.on('mounted move resized updated', updateActiveCard);
    splide.mount();
  });



  // FAQ Accordion
  const faqAccordions = document.querySelectorAll('[data-faq-accordion]');

  faqAccordions.forEach((accordion) => {
    const items = Array.from(accordion.querySelectorAll('.faq-accordion__item'));

    const openItem = (item) => {
      const panel = item.querySelector('[data-faq-panel]');
      const trigger = item.querySelector('[data-faq-trigger]');

      if (!panel || !trigger) {
        return;
      }

      panel.hidden = false;
      const fullHeight = panel.scrollHeight;
      panel.style.height = '0px';
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');

      requestAnimationFrame(() => {
        panel.style.height = `${fullHeight}px`;
      });
    };

    const closeItem = (item) => {
      const panel = item.querySelector('[data-faq-panel]');
      const trigger = item.querySelector('[data-faq-trigger]');

      if (!panel || !trigger) {
        return;
      }

      panel.style.height = `${panel.scrollHeight}px`;
      trigger.setAttribute('aria-expanded', 'false');
      item.classList.remove('is-open');

      requestAnimationFrame(() => {
        panel.style.height = '0px';
      });
    };

    items.forEach((item) => {
      const trigger = item.querySelector('[data-faq-trigger]');
      const panel = item.querySelector('[data-faq-panel]');

      if (!trigger || !panel) {
        return;
      }

      if (item.classList.contains('is-open')) {
        panel.hidden = false;
        panel.style.height = 'auto';
      } else {
        panel.hidden = true;
        panel.style.height = '0px';
      }

      panel.addEventListener('transitionend', () => {
        if (item.classList.contains('is-open')) {
          panel.style.height = 'auto';
        } else {
          panel.hidden = true;
        }
      });

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        items.forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains('is-open')) {
            closeItem(otherItem);
          }
        });

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  });


  
  
  

});
